import BaseModal from '..';
import { observer } from 'mobx-react-lite';
import { Button, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import client from '@/store/client';

const Component = observer((props) => {
  const {
    onClose, 
    onOk,
    title,
    desc,
    btnText = '立即升级',
  } = props;
  
  return (
    <ConfigProvider locale={zhCN}>
      <div 
        className="rounded-24px w-440px overflow-hidden"
        style={{
          background: 'linear-gradient(180deg, rgba(194, 217, 244, 0.5) 0%, rgba(194, 217, 244, 0) 85.09%)'
        }}
        >
        <div 
          className="px-24px pt-30px pb-20px"
          style={{
            background: 'url(https://p3.ssl.qhimg.com/t11098f6bcdace8dabd8cd7cb02.png) center top / 100% auto no-repeat'
          }}
          >
          <div className="text-24px font-bold leading-34px">
            版本更新提示
          </div>
          <div className="mt-24px text-16px leading-22px">
            {title}
          </div>
          <div className="mt-12px text-16px leading-22px text-black text-opacity-70 whitespace-pre-wrap">
            {desc}
          </div>
          <div className="mt-32px flex justify-end">
            <Button
              type='primary'
              className='ant-btn-black !w-128px !h-44px !rounded-12px !text-16px'
              onClick={
                () => {
                  client.openPage("/download?src=upgrade");
                  onOk();
                }
              }>
              {btnText}
            </Button>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
});

const UpgradeModal = {
  self: null,
  show(data) {
    return new Promise(resolve => {
      const handleOk = ok => {
        resolve(ok);
        this.close();
      };
      
      this.self = BaseModal.show({
        content: (
          <Component
            {...data}
            onClose={() => handleOk(false)}
            onOk={() => handleOk(true)}
          />
        ),
        wrapClassName: 'nw-base-modal nw-base-modal-p-0',
        afterClose: () => {
          data?.afterClose?.();
        },
      });
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
    }
  },
};

export default UpgradeModal;